module.exports = __webpack_public_path__ + "media/site/images/banners/banner-brief-74c76f5826870d437e0f10240f8f1009.svg";